import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function LatestUpdates() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
              最新更新
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              每日持续更新，精彩内容不容错过
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-1.5">
                  {article.category}
                </span>
                <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-0.5">
                    <i className="ri-eye-line text-xs"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}